import React from 'react';
import {
  ExpiredLinkContainer,
  ExpiredEmoji,
  ExpiredTitle,
  ExpiredDescription,
} from './HomePage.styles';

export const ExpiredLinkScreen: React.FC = () => {
  return (
    <ExpiredLinkContainer>
      <ExpiredEmoji>
        😞
      </ExpiredEmoji>

      <ExpiredTitle variant="h4">
        We&apos;re sorry…
      </ExpiredTitle>

      <ExpiredDescription>
        The QR Code/link used has expired
        <br />
        and is no longer accepting videos.
      </ExpiredDescription>
    </ExpiredLinkContainer>
  );
};
